import { type ComponentProps } from 'react';

import { analyticsProps } from '@class-ui/insights';
import { Dialog, styled } from '@mui/material';

import { useOnMessage } from '../../../hooks/useOnMessage';


const StyledIFrame = styled('iframe')`
    width: 100%;
    height: 100%;
    border: none;
`;

const StyledDialog = styled(Dialog)`
    & .MuiPaper-root {
        width: 60vw;
        max-width: 100%;
        height: 80vh;
        max-height: 100%;
        padding: 12px 8px 8px 8px;
    }
`;

export type GenericIFrameDialogProps = Omit<ComponentProps<typeof Dialog>, 'open'> & {
    url: string | null;
    handleClose: () => void;
};

export const GenericIFrameDialog = (props: GenericIFrameDialogProps) => {
    const { url, handleClose, ...other } = props;
    const open = url !== null;

    useOnMessage((funcName) => {
        if (funcName === 'close') {
            handleClose();
        }
    });

    return (
        <StyledDialog open={open} onClose={handleClose} {...analyticsProps('class-generic-iframe-dialog')} {...other}>
            {open && <StyledIFrame src={url} allowFullScreen />}
        </StyledDialog>
    );
};
